import { color, SaleStatus } from '@enums/enums';
import { OnSite } from '../constants/deliveryMethods';
import {
  Address,
  CustomerInfo,
  Order,
  OrderStatus,
  PaymentMethod,
  Product,
  ProductWearerType,
} from '../interfaces/interfaces';

export const loadingProduct: Product = {
  id: 0,
  sale: 0.1,
  external_id: '',
  name: '',
  category: { id: 0, name: 'loading', href: '', isLoading: true },
  brand: '',
  variants: [],
  description: '',
  price: 0.0,
  old_price: 0.0,
  wearer_type: ProductWearerType.Men,
  isLoading: true,
};

export const loadingAddress: Address = {
  street: 'Rue de la gare',
  number: '1',
  ZIP: 1920,
  city: 'Martigny',
  state: 'Valais',
  country: 'Switzerland',
};

export const orderStatus: OrderStatus[] = [
  { id: 'WAITING_MONEY', name: SaleStatus.WAITING_MONEY, description: '', color: color.Grey },
  { id: 'PAID', name: SaleStatus.PAID, description: '', color: color.Green },
  { id: 'PENDING', name: SaleStatus.PENDING, description: '', color: color.Orange },
  { id: 'SENT', name: SaleStatus.SENT, description: '', color: color.Green },
  { id: 'RETRIEVED', name: SaleStatus.RETRIEVED, description: '', color: color.Blue },
  { id: 'RETURNED', name: SaleStatus.RETURNED, description: '', color: color.Orange },
  { id: 'REFUNDED', name: SaleStatus.REFUNDED, description: '', color: color.Grey },
  { id: 'CLOSED', name: SaleStatus.CLOSED, description: '', color: color.Blue },
];

export const paymentMethod: PaymentMethod = {
  id: 1,
  IBAN: 'CH0989144364944361436',
  type: 'MasterCard',
};

export const address1: Address = {
  street: 'Hauptstrasse',
  number: '93',
  city: 'Mönchaltorf',
  ZIP: 8617,
  state: 'Bern',
  country: 'Switzerland',
};

// export const business: Business = {
//   email: 'nonux_owoje68@gmail.com',
//   first_name: 'Prénom',
//   invoice_address: address1,
//   last_name: 'Nom de famille',
//   region: 'Valais',
//   phone: '000 000 00 00',
//   id: 1,
//   business_name: 'BUSINESSNAME',
//   paymentMethod: paymentMethod,
// };

export const waitingMoney: OrderStatus = {
  id: 'WaitingMoney',
  name: SaleStatus.WAITING_MONEY,
  description: '',
  color: color.Grey,
};

export const corine: CustomerInfo = {
  firstname: 'Corrinne',
  lastname: 'Clears',
  email: 'cclears0@goo.ne.jp',
  phone: '+81 645 603 1348',
  // "invoice_address": "62 Thierer Pass",
  // "delivery_address": "86 Schmedeman Terrace",
};
export const bertie: CustomerInfo = {
  firstname: 'Bertie',
  lastname: 'Narbett',
  email: 'bnarbett3@sbwire.com',
  phone: '+62 550 779 1778',
  // "invoice_address": "85793 Meadow Vale Park",
  // "delivery_address": "6 Scofield Terrace",
};

// {
//     "id": 17,
//     "settled_date": null,
//     "status": "PENDING",
//     "customer": {},
//     "items": [
//       {
//         "quantity": 5,
//         "product": {
//           "id": 3,
//           "name": "Ski Tourterelle",
//           "brand": "EverLayer",
//           "description": "Inventore error et incidunt ut vel omnis quo consequatur. Dolor voluptas ut iste iusto ut. Suscipit rerum incidunt ad culpa eaque iste deserunt temporibus. Quaerat omnis ex dolores qui occaecati enim.",
//           "price": 6.16,
//           "old_price": 61.64,
//           "sale": 0.9,
//           "external_id": "3609964",
//           "wearer_type": "UNISEX",
//           "company_id": 2,
//           "product_variant_id": 9
//         },
//         "product_size": {
//           "id": 2,
//           "name": "EXTRA_SMALL",
//           "value": "XS"
//         }
//       },
//       {
//         "quantity": 4,
//         "product": {
//           "id": 3,
//           "name": "Ski Tourterelle",
//           "brand": "EverLayer",
//           "description": "Inventore error et incidunt ut vel omnis quo consequatur. Dolor voluptas ut iste iusto ut. Suscipit rerum incidunt ad culpa eaque iste deserunt temporibus. Quaerat omnis ex dolores qui occaecati enim.",
//           "price": 6.16,
//           "old_price": 61.64,
//           "sale": 0.9,
//           "external_id": "3609964",
//           "wearer_type": "UNISEX",
//           "company_id": 2,
//           "product_variant_id": 11
//         },
//         "product_size": {
//           "id": 7,
//           "name": "EXTRA_EXTRA_LARGE",
//           "value": "XXL"
//         }
//       }
//     ]
//   }

export const orders: Order[] = [
  {
    id: 1,
    settled_date: new Date(),
    createdAt: new Date(),
    updatedAt: new Date(),
    customer: corine,
    deliveryAddress: loadingAddress,
    invoiceAddress: loadingAddress,
    deliveryMethode: OnSite,
    status: SaleStatus.PENDING,
    items: [
      {
        size: {
          id: 1,
          name: 'Loading',
          value: 'XXL',
        },
        color: {
          id: 1,
          name: 'Loading',
          value: '#ffffff',
        },
        quantity: 1,
        product: loadingProduct,
      },
      {
        size: {
          id: 1,
          name: 'Loading',
          value: 'XXL',
        },
        color: {
          id: 1,
          name: 'Loading',
          value: '#ffffff',
        },
        quantity: 1,
        product: loadingProduct,
      },
      {
        size: {
          id: 1,
          name: 'Loading',
          value: 'XXL',
        },
        color: {
          id: 1,
          name: 'Loading',
          value: '#ffffff',
        },
        quantity: 1,
        product: loadingProduct,
      },
    ],
  },
];

// export const businesses: Business[] = [business, business, business, business];
// export const transactions: Transaction[] = [
//   { id: 1, date: 'December 17, 2023 03:24:00', business: business, consumer: bertie, order_status: waitingMoney },
//   { id: 1, date: 'December 18, 2023 03:24:00', business: business, consumer: bertie, order_status: waitingMoney },
//   { id: 1, date: 'December 19, 2023 03:24:00', business: business, consumer: bertie, order_status: waitingMoney },
//   { id: 1, date: 'December 12, 2023 03:24:00', business: business, consumer: bertie, order_status: waitingMoney },
//   { id: 1, date: 'December 17, 2023 03:24:00', business: business, consumer: bertie, order_status: waitingMoney },
// ];

export const userTypes: any[] = [{ name: 'Tous' }, { name: 'Hommes' }, { name: 'Femmes' }, { name: 'Enfants' }];
